var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat28X28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 22 C 10.552 22 11 22.448 11 23 C 11 23.552 10.552 24 10 24 C 9.448 24 9 23.552 9 23 C 9 22.448 9.448 22 10 22 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 21 C 5.552 21 6 21.448 6 22 C 6 22.552 5.552 23 5 23 C 4.448 23 4 22.552 4 22 C 4 21.448 4.448 21 5 21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23 13 C 23.552 13 24 13.448 24 14 C 24 14.552 23.552 15 23 15 C 22.448 15 22 14.552 22 14 C 22 13.448 22.448 13 23 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22 17 C 22.552 17 23 17.448 23 18 C 23 18.552 22.552 19 22 19 C 21.448 19 21 18.552 21 18 C 21 17.448 21.448 17 22 17 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 0 C 10.552 0 11 0.448 11 1 C 11 1.552 10.552 2 10 2 C 9.448 2 9 1.552 9 1 C 9 0.448 9.448 0 10 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 1 C 6.552 1 7 1.448 7 2 C 7 2.552 6.552 3 6 3 C 5.448 3 5 2.552 5 2 C 5 1.448 5.448 1 6 1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 5 C 2.552 5 3 5.448 3 6 C 3 6.552 2.552 7 2 7 C 1.448 7 1 6.552 1 6 C 1 5.448 1.448 5 2 5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14 0 C 14.552 0 15 0.448 15 1 C 15 1.552 14.552 2 14 2 C 13.448 2 13 1.552 13 1 C 13 0.448 13.448 0 14 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 22 C 1.552 22 2 22.448 2 23 C 2 23.552 1.552 24 1 24 C 0.448 24 0 23.552 0 23 C 0 22.448 0.448 22 1 22 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 18 C 2.552 18 3 18.448 3 19 C 3 19.552 2.552 20 2 20 C 1.448 20 1 19.552 1 19 C 1 18.448 1.448 18 2 18 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14 22 C 14.552 22 15 22.448 15 23 C 15 23.552 14.552 24 14 24 C 13.448 24 13 23.552 13 23 C 13 22.448 13.448 22 14 22 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22 5 C 22.552 5 23 5.448 23 6 C 23 6.552 22.552 7 22 7 C 21.448 7 21 6.552 21 6 C 21 5.448 21.448 5 22 5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23 9 C 23.552 9 24 9.448 24 10 C 24 10.552 23.552 11 23 11 C 22.448 11 22 10.552 22 10 C 22 9.448 22.448 9 23 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18 21 C 18.552 21 19 21.448 19 22 C 19 22.552 18.552 23 18 23 C 17.448 23 17 22.552 17 22 C 17 21.448 17.448 21 18 21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18 1 C 18.552 1 19 1.448 19 2 C 19 2.552 18.552 3 18 3 C 17.448 3 17 2.552 17 2 C 17 1.448 17.448 1 18 1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 13 C 1.552 13 2 13.448 2 14 C 2 14.552 1.552 15 1 15 C 0.448 15 0 14.552 0 14 C 0 13.448 0.448 13 1 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 9 C 1.552 9 2 9.448 2 10 C 2 10.552 1.552 11 1 11 C 0.448 11 0 10.552 0 10 C 0 9.448 0.448 9 1 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 13 L 15 13 L 15 14 L 6 14 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 10 L 18 10 L 18 11 L 6 11 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat28X28);
export default __webpack_public_path__ + "static/media/chat-28x28.a8150ef56af9f8363d8b8c110cf75d26.svg";
export { ForwardRef as ReactComponent };